module.exports = __webpack_public_path__ + "static/media/Invite_sent.c5635a72.svg";